import React, {useState, useEffect} from "react";
import {Trans, useTranslation} from "react-i18next";

const Recommendations = ({
  recommendationUrl,
  limit = 4,
  displayGrid = false,
}: {
  recommendationUrl: string;
  limit?: number;
  displayGrid?: boolean;
}): React.ReactElement => {
  if (typeof limit !== "number") {
    throw new Error("Limit must be a number");
  }

  const {t} = useTranslation();

  const [recommendations, setRecommendations] = useState(null);

  const fallbackUrl =
    "/recommendations/products.json?section_id=template--19881981116740__main-product-tailwind&product_id=6569289973860&intent=related";

  useEffect(() => {
    fetch(recommendationUrl + "&limit=" + limit.toString())
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then((data) => {
        if (data.products.length === 0) {
          throw new Error("No products returned");
        }
        setRecommendations(data);
      })
      .catch(() => {
        fetch(fallbackUrl + "&limit=" + limit.toString())
          .then((res) => res.json())
          .then(setRecommendations);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-7xl mx-auto">
      <div className="px-4 pb-4">
        <span className="leading-10 text-gray-600 max-sm:text-sm">
          {t("recommendations.title")}
        </span>
        <h1>
          <Trans i18nKey={"recommendations.subtitle"} components={{br: <br className="hidden md:inline"/>}}/>
        </h1>
      </div>
      <div
        className={`${
          displayGrid
            ? "grid grid-cols-1 md:grid-cols-2 gap-2"
            : "flex px-2 md:px-4 gap-2 md:gap-3 overflow-x-auto"
        }`}
      >
        {recommendations &&
          recommendations.products.map((product: any, i: number) => (
            <a
              key={i}
              className={`${displayGrid ? "w-full group" : "flex-1 group"}`}
              href={product.url}
            >
              <img
                className="w-full min-w-[14rem] aspect-[3/2] rounded-xl"
                src={product.featured_image + "?width=300&height=200"}
                width="300"
                height="200"
                loading="lazy"
              />
              <div className="py-2 text-green-900 flex gap-2 justify-between items-start">
                <span className="line-clamp-2 text-ellipsis overflow-hidden">
                  {product.title}
                </span>
                {/*
                  <div className="flex items-center gap-1 [&>svg]:w-3 [word-spacing:-1px] h-6 flex-shrink-0 mr-2 md:mr-1">
                    <Icon.Clock />
                    <span className="text-[10px] uppercase tracking-wider">
                      {product.metafields.recipe.preparationtime} min
                    </span>
                  </div>
                  XXX: We would have to separately query prep time
                  */}
              </div>
            </a>
          ))}
      </div>
    </div>
  );
};

export {Recommendations};
